<template>
	<div class="container">
		<div class="top-wrapper">
			<img class="top-img"
				:src="topImg" />
			<div class="name-box">
				<div class="name-sub">Our Products</div>
				<div class="name-ch">产品中心</div>
			</div>
		</div>
		<div class="content-wrapper">
			<div class="center-section">
				<div class="section-top">
					<div class="section-title">
						产品中心
					</div>
					<!-- 	<div class="section-top-title-sub">
						我們成立於2024年，專注營養補充品出口與進口。供應商嚴選、品質把關、快速出貨，是我們的承諾。
					</div> -->
				</div>
				<!-- <div class="product-list">
					<div class="product-item"
						v-for="(item, index) in productList"
						:key="index"></div>
				</div> -->

				<img class="center-img"
					:src="centerImg" />
			</div>
			<div class="products-section">
				<div class="section-title">
					产品列表
				</div>
				<div class="products-box">
					<div class="products-item"
						v-for="(item, index) in productList"
						:key="index">
						<img class="products-img"
							:src="item.url" />
						<div class="products-name">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<page-footer></page-footer>
	</div>
</template>

<script>
	import pageFooter from "@/components/common/page-footer/page-footer.vue"
	export default {
		name: 'home',
		components: {
			pageFooter
		},
		data() {
			return {
				topImg: require('@/assets/pro1.png'),
				centerImg: require('@/assets/pro2.png'),
				productList: [{
						url: "http://image.jyksys.com/JYKImgService/Upload/pi/1044/10266580/L2.JPG",
						title: "黄秋葵牡蛎肽"
					},
					{
						url: "http://image.jyksys.com/JYKImgService/Upload/pi/1044/10266579/L3.JPG",
						title: "花生肽"
					},
					{
						url: "http://image.jyksys.com/JYKImgService/Upload/pi/1044/10211798/L3.JPG",
						title: "大豆肽（小分子高活性）"
					},
					{
						url: "http://image.jyksys.com/JYKImgService/Upload/pi/1044/10889460/L3.JPG",
						title: "鑫糖肽Dibipro"
					},
					{
						url: "http://image.jyksys.com/JYKImgService/Upload/pi/1044/10266583/L1.JPG",
						title: "轻草堂秋葵品萃饮"
					},
					{
						url: "http://image.jyksys.com/JYKImgService/Upload/pi/1044/10616287/L4.JPG",
						title: "Super NMN 9000"
					}
				]
			}
		}
	}
</script>

<style lang="scss"
	scoped>
	.container {
		text-align: left;
	}

	.top-wrapper {
		position: relative;

		.top-img {
			width: 100%;
			height: 1080px;
		}

		.name-box {
			position: absolute;
			top: 30%;
			transform: translateY(-50%);
			left: 10%;
			color: #fff;
			text-align: left;

			display: flex;
			flex-direction: column;
			display: inline;

			.name-sub {
				position: relative;
				font-size: 12px;
				text-align: left;
				padding: 0 16px;
				width: 75px;

				&::before {
					position: absolute;
					content: "";
					height: 1px;
					width: 15px;
					top: 50%;
					transform: translateY(-50%);
					left: -2px;
					background: #fff;
				}

				&::after {
					position: absolute;
					content: "";
					height: 1px;
					width: 15px;
					top: 50%;
					transform: translateY(-50%);
					right: -2px;
					background: #fff;
				}
			}

			.name-ch {
				margin-top: 10px;
				font-weight: bold;
				font-size: 26px;
			}
		}
	}

	.content-wrapper {
		width: 60%;
		margin: auto;
		margin-top: 30px;

		.center-section {
			color: #333;

			.section-top {
				display: flex;
				justify-content: space-between;


				.section-top-title-sub {
					font-size: 12px;
					max-width: 350px;
				}
			}

			.center-img {
				width: 100%;
				height: auto;
				margin-top: 30px;
			}
		}

		.products-section {
			margin-top: 30px;

			.section-title {}

			.products-box {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				row-gap: 10px;
				column-gap: 10px;
				margin-top: 30px;

				.products-item {
					box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.04);

					.products-img {
						width: 100%;
						height: 350px;
						background-color: #f8f8f8;
						border: 1px solid #f8f8f8;
					}

					.products-name {
						margin-top: 10px;
						font-size: 18px;
						color: #333333;
						font-weight: bold;
						padding: 10px 0 20px 5px;

					}
				}
			}
		}

	}

	.section-title {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		position: relative;
		height: 30px;

		&:before {
			position: absolute;
			content: "";
			left: 0;
			width: 50px;
			height: 4px;
			background-color: #3E8CEF;
			bottom: -10px;
		}
	}
</style>